//Base url for axios/API
const dev_app_api = process.env.DEV_PROXY_APP_API?process.env.DEV_PROXY_APP_API:'https://localhost:44314'
const dev_app_auth = process.env.DEV_PROXY_AUTH_API?process.env.DEV_PROXY_AUTH_API:'https://localhost:44377'

export const BASE_URL = process.env.NODE_ENV==="production"? process.env.REACT_APP_API : dev_app_api
export const BASE_AUTH_URL = process.env.NODE_ENV==="production" ? process.env.REACT_APP_AUTH_API : dev_app_auth
export const APP_CLIENT_ID = process.env.APP_CLIENT_ID ? process.env.APP_CLIENT_ID : 'AgreCalc_Swagger'
export const APP_SCOPE = process.env.APP_SCOPE ? process.env.APP_SCOPE : 'AgreCalc'
export const APP_IDLE_TIME = 4*60*60*1000
